import { SET_REQUEST_FORM } from './requestFormTypes';

export const setRequestForm = (payload) => ({
    type: SET_REQUEST_FORM,
    payload,
});